/**
 * Transform: insight → chat-prompt (guided approach)
 *
 * Input:  Lens insight data (code element + concept + paradigm)
 * Output: Chat prompt with guided questions
 * Approach: Structured learning with specific follow-up questions
 *
 * Used by: SyntaxLensWidget, NotebookView, SlideshowOverlay
 */

export const INSIGHT_TO_CHAT_PROMPT_GUIDED = {
  inputType: 'insight',
  outputType: 'chat-prompt',
  approach: 'guided',

  buildIntro: (sourceLang: string, targetLang: string, codeElement: string) =>
    `I'm learning ${targetLang} and I'm familiar with ${sourceLang}. ` +
    `I'm looking at this code element: \`${codeElement}\`\n\n`,

  buildQuestions: (targetLang: string) =>
    `\n\nCan you help me understand this concept better? Please explain:\n` +
    `1. When and why would I use this in ${targetLang}?\n` +
    `2. What are common patterns or best practices?\n` +
    `3. Are there any gotchas or important details I should know?`
}

export default INSIGHT_TO_CHAT_PROMPT_GUIDED
